import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  toggle(event) {
    event.preventDefault()
    this.menuTarget.classList.toggle("hidden")
  }

  hide() {
    this.menuTarget.classList.add("hidden")
  }

  hideOnOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.hide()
    }
  }

  hideOnEscape(event) {
    if (event.key === "Escape") {
      this.hide()
    }
  }
}
